import React from 'react';

import IconSingleunitfranchisecenter from '../icons/IconSingleunitfranchisecenter';
 import IconMasterFranchise from '../icons/iconMasterFranchise';
import IconSupplementalProgram from '../icons/IconSupplementalProgram';

const FranchiseOptions = ({toSection,section}) => {
  const options = [
    {
      title: "Single unit franchise center",
      description: "Establish or expand your presence with a permanent location and become an integral part of your community. Attract children to your center with a variety of offerings: education programs, holiday camps, and birthday parties -- three resilient, recession-proof businesses all in one place!",
      iconUrl: <IconSingleunitfranchisecenter />
    },
    {
      title: "Master franchise",
      description: "Have a big vision? If you have experience in managing multi-site operations, or ambitions to take on a leadership role with one of the world's most promising new franchises, and you're passionate about people and processes, let's connect!",
      iconUrl: <IconMasterFranchise />
    },
    {
      title: "Supplemental program",
      description: "Already running a child-focused business? By incorporating Tinker Labs into your existing setup, you're adding an innovative and engaging program that appeals to both kids and parents alike. Tinker Labs makes it easy to introduce an additional revenue stream without a large investment, while bringing more families through your doors.",
      iconUrl: <IconSupplementalProgram />
    }
  ];

  const gradientColors = [
    'bg-[#0088CE] text-white', // Blue to Purple
    'bg-[#CD2628]',  // Yellow to Orange
    'bg-[#67B437]'   // Green to Cyan
  ];
  const textColors = [
    'text-white',  // Yellow to Orange
    'text-white',  // Blue to Purple
    'text-white'   // Green to Cyan
  ];
  return (
    <div style={{marginTop: '-40px'}} id={section}  className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#c7e7ff"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-white relative py-20">
        <div className="container mx-auto px-4 py-20">
          <div className="text-center   mx-auto mb-16">
            <h2 className="font-['Grandstander']  text-4xl font-extrabold text-[#002147] mb-4">
              Franchise options
            </h2>
            <p className="font-['Lexend'] text-xl text-gray-600">
              Choose the option best for you
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8  mx-auto">
            {options.map((option, index) => (
              <div 
                key={index} 
                className="relative bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
              >
                {/* Gradient Background */}
                <div className={`absolute inset-0 ${gradientColors[index]} `}></div>
                
                {/* Content */}
                <div className="relative p-8">
                  {/* Icon */}
                  <div className="w-16 h-16 mb-6 mx-auto">
                   {option.iconUrl}
                  </div>
                  
                  {/* Title */}
                  <h3 className="font-['Lexend'] text-xl font-semibold  text-white mb-4 text-center">
                    {option.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="font-['Lexend'] text-white  leading-relaxed">
                    {option.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#c7e7ff"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default FranchiseOptions;